/**
 * @generated SignedSource<<1015f835791c9dd9982f18746a41faab>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RssMaxAge = "ONE_DAY" | "ONE_MONTH" | "ONE_WEEK" | "%future added value";
export type RssMaxItemsPerEpisode = "FIVE" | "ONE" | "TEN" | "THREE" | "%future added value";
export type RssProcessingDelay = "INSTANT" | "ONE_DAY" | "ONE_HOUR" | "SIX_HOURS" | "TWO_DAYS" | "%future added value";
export type SourceType = "BING_NEWS" | "GOOGLE_NEWS" | "REDDIT" | "RSS" | "SERPER_NEWS" | "TWITTER" | "YOU_TUBE" | "%future added value";
export type TopicType = "NEWS" | "RSS" | "%future added value";
export type TopicVisibility = "PRIVATE" | "PUBLIC" | "UNLISTED" | "%future added value";
export type TtsEngine = "ELEVEN_LABS" | "POLLY" | "%future added value";
export type CreateTopicInput = {
  applePodcastsUrl?: string | null | undefined;
  cronSchedule?: string | null | undefined;
  customHostName?: string | null | undefined;
  customHostPersonality?: string | null | undefined;
  name: string;
  rssSettings?: RssSettingsInput | null | undefined;
  s3AnchorImagePath?: string | null | undefined;
  s3IntroPath?: string | null | undefined;
  s3OutroPath?: string | null | undefined;
  slug: string;
  sources: ReadonlyArray<SourceInput>;
  spotifyUrl?: string | null | undefined;
  stylePrompt?: string;
  topicType?: TopicType;
  ttsEngine?: TtsEngine;
  ttsModel?: string | null | undefined;
  visibility?: TopicVisibility;
  voiceId: string;
};
export type SourceInput = {
  domainFilter?: string | null | undefined;
  identifier: string;
  label?: string | null | undefined;
  sourceType: SourceType;
};
export type RssSettingsInput = {
  maxAge: RssMaxAge;
  maxItemsPerEpisode: RssMaxItemsPerEpisode;
  processingDelay: RssProcessingDelay;
};
export type TopicFormCreateMutation$variables = {
  input: CreateTopicInput;
};
export type TopicFormCreateMutation$data = {
  readonly createTopic: {
    readonly topic: {
      readonly id: string;
      readonly slug: string;
      readonly " $fragmentSpreads": FragmentRefs<"TopicList_topic">;
    } | null | undefined;
    readonly userErrors: ReadonlyArray<{
      readonly code: string | null | undefined;
      readonly field: string | null | undefined;
      readonly message: string;
    }>;
  };
};
export type TopicFormCreateMutation = {
  response: TopicFormCreateMutation$data;
  variables: TopicFormCreateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "UserError",
  "kind": "LinkedField",
  "name": "userErrors",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "field",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "code",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TopicFormCreateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateTopicPayload",
        "kind": "LinkedField",
        "name": "createTopic",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Topic",
            "kind": "LinkedField",
            "name": "topic",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "TopicList_topic"
              }
            ],
            "storageKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "MutationRoot",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TopicFormCreateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateTopicPayload",
        "kind": "LinkedField",
        "name": "createTopic",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Topic",
            "kind": "LinkedField",
            "name": "topic",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isActive",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "visibility",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "status",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "episodeCount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lastIngestionAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lastExecutionStatus",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lastExecutionStartedAt",
                "storageKey": null
              },
              {
                "alias": "canTriggerIngestion",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "action",
                    "value": "TRIGGER_INGESTION"
                  }
                ],
                "kind": "ScalarField",
                "name": "canAct",
                "storageKey": "canAct(action:\"TRIGGER_INGESTION\")"
              }
            ],
            "storageKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "883483588d5b614d1208a5a26f4a1d08",
    "id": null,
    "metadata": {},
    "name": "TopicFormCreateMutation",
    "operationKind": "mutation",
    "text": "mutation TopicFormCreateMutation(\n  $input: CreateTopicInput!\n) {\n  createTopic(input: $input) {\n    topic {\n      id\n      slug\n      ...TopicList_topic\n    }\n    userErrors {\n      field\n      message\n      code\n    }\n  }\n}\n\nfragment TopicList_topic on Topic {\n  id\n  slug\n  name\n  isActive\n  visibility\n  status\n  episodeCount\n  lastIngestionAt\n  lastExecutionStatus\n  lastExecutionStartedAt\n  canTriggerIngestion: canAct(action: TRIGGER_INGESTION)\n}\n"
  }
};
})();

(node as any).hash = "84c34503c1d9749259b4ff41f389e3f9";

export default node;
